import { globalEvent } from '@shared/easyfy.core';

export class Accordion {
  constructor() {
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'accordion-toggle',
          callback: this.accordionToggle.bind(this),
        },
      ],
    });
  }

  accordionToggle(e: Event) {
    if (e?.preventDefault) e.preventDefault();
    let el: HTMLElement;
    if (e.target) el = e.target as HTMLElement;
    if (el.nodeName !== 'A') el = el.parentNode as HTMLElement;

    const container: HTMLElement = el.closest('.accordion-toggle') as HTMLElement;

    if (container) {
      const content: HTMLElement = container.querySelector('.accordion-content') as HTMLElement;
      const replaceText: string = el.dataset.text;
      const currentTextElement: HTMLElement = el.querySelector('span') as HTMLElement;
      const currentText: string = currentTextElement ? currentTextElement.textContent || '' : '';
      if (content) {
        container.hasAttribute('open') ? container.removeAttribute('open') : container.setAttribute('open', '');
        if (replaceText) {
          currentTextElement.innerText = replaceText;
          el.dataset.text = currentText;
        }
      }
    }
  }
}
